import { render, staticRenderFns } from "./CenterBody.vue?vue&type=template&id=7c53951f&scoped=true"
import script from "./CenterBody.vue?vue&type=script&lang=js"
export * from "./CenterBody.vue?vue&type=script&lang=js"
import style0 from "./CenterBody.vue?vue&type=style&index=0&id=7c53951f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c53951f",
  null
  
)

export default component.exports